// removed by extract-text-webpack-plugin
module.exports = {"block":"Header__block___j6zsJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.css
// module id = 108
// module chunks = 0